import React from 'react';
import config from '../../config';

const TsAndCs = () => {
  return (
    <React.Fragment>
      <div className='wf-account__text'>
        <span>Please note that by creating an account you accept our </span>
        <a
          className='wf-account__link'
          href={`${config.WordPressURL}privacy-policy/`}
          target='_blank'
          rel='noreferrer'
        >
          {`Privacy & Cookies policy`}
        </a>
        , and our{' '}
        <a
          className='wf-account__link'
          href={`${config.WordPressURL}terms-conditions`}
          target='_blank'
          rel='noreferrer'
        >
          {`Terms & Conditions`}
        </a>
        .
      </div>
      {/* <div className="wf-account__text">
        {`© regulationcity.com`}
      </div> */}
    </React.Fragment>
  );
};

export default TsAndCs;
